import React from "react";
import { withNavBars } from "../../HOCs";
import AnnounsmentNew from "./announsmentNew";
class AnnounsmentParent extends React.Component {
  render() {
    return <AnnounsmentNew />;
  }
}
const props = {
  boxShadow: false,
};
export default withNavBars(AnnounsmentParent, props);
